module.exports = __webpack_public_path__ + "static/media/kick.a2babbf9.ogg";